<!--========================== dropdown start =============================-->
<section class="mis_dropdown">
    <div class="container">
        <div class="row">
            <!-- <section  *ngIf="backarrow">
                <div class="col-md-12">
                    <button (click)="navigateBackward()" class="btn btn-light backbtn_mb"><span><i class="fa fa-arrow-left back_btn"
                                aria-hidden="true"></i></span></button>
                </div>
            </section> -->


            <div class="col-md-12">
                <div class="dropfilter__flex">
                    <div class="section" *ngIf="backarrow">
                        <button (click)="navigateBackward()" class="btn btn-light backbtn_mb"><span><i
                                    class="fa fa-arrow-left back_btn" aria-hidden="true"></i></span></button>
                    </div>
                    <div class="drop__widthone">
                        <div class="dropsearch_flex">
                            <div class="dropwidth">
                                <select name="dropdown" class="mis_select" id="dropdown"
                                    (change)="onOptionsSelected($event)">
                                    <!-- <option value="All">All</option> -->
                                    <option value="Campus">Campus</option>
                                    <option value="City">City</option>
                                    <option value="State">State</option>
                                </select>
                            </div>
                            <div class="searchwidth">
                                <div class="input-group">
                                    <input type="text" class="form-control misinput_control" placeholder="Search"
                                        [(ngModel)]="searchTerm" (keyup)="search($event)">
                                    <div class="input-group-btn">
                                        <button class="btn drop_iconsearch" type="submit">
                                            <i class="fa fa-search" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="dropdown">
                        <button class="dropdown-toggle month_dropshow" type="button" id="dropdownMenuButton1"
                            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <img src="../../assets/image/filter.png" alt="filter" class="cctv_filter">
                        </button>
                        <ul class="dropdown-menu dropdown-menu-right mis_select_show"
                            aria-labelledby="dropdownMenuButton1">
                            <li><a (click)="connected()" class="dropdown-item">Connected</a></li>
                            <li><a (click)="notconnected()" class="dropdown-item">Not Connected</a></li>
                            <li><a (click)="streaming()" class="dropdown-item">Video Streaming</a></li>
                            <li><a (click)="notstreaming()" class="dropdown-item">Video Not Streaming</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="search_mobshow">
                    <div>
                        <h6 class="mob_searchhd">Search by</h6>
                    </div>
                    <div class="searchitem_scroll">
                        <ul class="search_items">
                            <li><a href="#">Admission no </a></li>
                            <li><a href="#">School</a></li>
                            <li><a href="#">State</a></li>
                            <li><a href="#">Zone</a></li>
                            <li><a href="#">City</a></li>
                            <li><a href="#">Campus</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!--======================= dropdowm end ========================-->

<!--======================= Back Arrow Button ===================-->

<!-- <div class="section" *ngIf="backarrow">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <button (click)="navigateBackward()" class="btn btn-light backbtn_mb"><span><i class="fa fa-arrow-left back_btn"
                            aria-hidden="true"></i></span></button>
            </div>
        </div>
    </div>
</div> -->
<div class="container">
    <div class="row">
        <div class="col-md-12">
            <div class="breadcrumb">
                <ng-container *ngFor="let breadcrumb of  history">
                    <span (click)="onChangehistory(breadcrumb)">{{breadcrumb.campusName}}</span> <span> > </span>
                </ng-container>
            </div>

        </div>
    </div>
</div>
<!--========================= section start ==========================-->

<div *ngIf="show && !showsecond">
    <section class="section_one">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <!-- <div class="vector">
                        <span><i routerLink="/totaldvr" class="fa fa-th-large" aria-hidden="true"></i></span>
                    </div> -->
                    <div class="state__sec">
                        <ul class="state__list">
                            <li
                                *ngFor="let data of campusdata | filter:searchkey: selected_value == 'Campus' ? 'campusName' : selected_value == 'City' ? 'cityName' : 'stateName' ">
                                <div class="statelist__flex">
                                    <div class="statetitle__flex">
                                        <div>
                                            <h5 class="state__name">
                                                {{data.campusName}}
                                                {{data.cityName}} {{data.stateName}}


                                            </h5>
                                        </div>
                                        <div>
                                            <h6 class="state__dvr">Total DVR : <span
                                                    class="dvr__color">{{data.totalDvrs}}</span></h6>
                                        </div>
                                    </div>
                                    <div class="cctv__colflex">
                                        <div class="cctv__camflex">
                                            <div>
                                                <figure class="mb-0">
                                                    <img src="../../assets/image/cctv.jpg" class="cctv" alt="cctv">
                                                </figure>
                                            </div>
                                            <div>
                                                <h6 class="cctv__title" (click)="save(data)">CCTV Installed</h6>
                                                <h5 class="cctv__number">{{data.totalCamerasInstalled | million}}</h5>
                                            </div>
                                        </div>
                                        <div>
                                            <h6 class="cctv__title" (click)="save(data)">Connected</h6>
                                            <h5 class="cctv__number">{{data.totalConnected | million}}</h5>
                                        </div>
                                        <div>
                                            <h6 class="cctv__title" (click)="save(data)">Not Connected</h6>
                                            <h5 class="cctv__number">{{data.totalNotConnected | million}}</h5>
                                        </div>
                                        <div>
                                            <h6 class="cctv__title" (click)="save(data)">Streaming</h6>
                                            <h5 class="cctv__number">{{data.totalVideoStreaming | million}}</h5>
                                        </div>
                                        <div>
                                            <h6 class="cctv__title" (click)="save(data)">No Video</h6>
                                            <h5 class="cctv__number">{{data.totalVideoNotStreaming | million}}</h5>
                                        </div>
                                        <div (click)="save(data)">
                                            <figure class="mb-0">
                                                <img src="../../assets/image/rightarrow.png" class="rightarrow"
                                                    alt="rightarrow">
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<!--================== navitage to right click ====================-->

<div *ngIf="!show && !showsecond">
    <div *ngIf="selected_value==='Campus' ">
        <app-campus [id]="id"></app-campus>
    </div>
    <div *ngIf="selected_value==='State' ">
        <app-state [id]="id" (buttonWasClicked)="changeType($event)"></app-state>
    </div>
    <div *ngIf="selected_value==='City' ">
        <app-city [id1]="id" (buttonWasClicked)="change($event)"></app-city>
    </div>
</div>

<!--====== filter sorting connected & Not connected & streaming & Notsteaming ====-->

<div *ngIf="showsecond">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
              
                <div class="table">
                   
                    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
                        class="mat-elevation-z8">
                        <ng-container matColumnDef="stateName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                State
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.stateName}}</td>
                        </ng-container>
                        <ng-container matColumnDef="cityName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                City
                            </th>
                            <td mat-cell *matCellDef="let element">{{element.cityName}}</td>
                        </ng-container>
                        <ng-container matColumnDef="campusName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Campus
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.campusName}}</td>
                        </ng-container>
                        <ng-container matColumnDef="totalCamerasInstalled">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Installed
                            </th>
                            <td mat-cell *matCellDef="let element" class="installnum"> {{element.totalCamerasInstalled}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="totalConnected">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Connected
                            </th>
                            <td mat-cell *matCellDef="let element" class="installnum" (click)="actionclick(element)">
                                <span [ngClass]="{active1:currentActiveData ==='connected'}">
                                    {{element.totalConnected}}</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="totalNotConnected">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                No Connected
                            </th>
                            <td mat-cell *matCellDef="let element" class="installnum" (click)="action1click(element)">
                                <span
                                    [ngClass]="{active2:currentActiveData ==='not connected'}">{{element.totalNotConnected}}</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="totalVideoStreaming">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Streaming
                            </th>
                            <td mat-cell *matCellDef="let element" class="installnum" (click)="action2click(element)">
                                <span [ngClass]="{active3:currentActiveData ==='streaming'}">
                                    {{element.totalVideoStreaming}}</span>
                            </td>
                        </ng-container>
                           
                        <ng-container matColumnDef="totalVideoNotStreaming">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                No Video
                            </th>
                            <td mat-cell *matCellDef="let element" class="installnum" (click)="action3click(element)">
                                <span
                                    [ngClass]="{active4:currentActiveData ==='notstreaming'}">{{element.totalVideoNotStreaming}}</span>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                 
                </div>
                <div class="nodatafound">
                    <div *ngIf="filter.length<=0">
                        <section class="section_one">
                            <div class="cctvcouncelling__sec">
                                <div class="councellist__flex">
                                    <div>
                                        <div class="nodata_center">
                                            <figure class="mb-0">
                                                <img src="../../../../assets/image/nodata.png" alt="nodata"
                                                    class="nodata">
                                            </figure>
                                            <p class="no_data">No Data Found</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--=========================== loader =========================-->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>